import React, { useState, useRef, useEffect } from 'react';
import { getFilters, createFilter, updateFilter, softDeleteFilter } from '../../Services/FilterService';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import Overlay from '../../Components/Overlay/Overlay';
import { handlerFormError, uuid } from '../../Utils/Utils';
import EditButton from '../../Components/Button/EditButton';
import { useDispatch } from 'react-redux';
import { setModuleName } from '../../Stores/Action/AppAction';

let processingId = -1;

const FilterScreen = () => {
    const mTable = useRef();
    const dispatch = useDispatch();
    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        defaultValues: {
            filter_name: '',
            is_active: true
        }
    });

    const [state, setState] = useState({
        showForm: false,
        filter: {
            filter_name: '',
            is_active: true
        },
        processing: false
    });

    useEffect(() => {
        dispatch(setModuleName('Filter'));
    }, []);

    const changeStatus = (username, status) => {
        const body = {
            is_active: status
        }

        softDeleteFilter(username, body, res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Change status success',
                    text: 'Data has been changed!'
                }).then(res => { mTable.current.refresh(); });
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Change status fail',
                text: 'Data can not be changed!'
            });
        });
    }

    const columns = [
        { id: uuid(), title: 'Filter Name', field: 'filter_name', sortable: true },
        {
            id: uuid(),
            title: 'Active',
            field: 'is_active',
            sortable: true,
            options: [
              {
                label: 'Active',
                value: true
              },
              {
                label: 'Inactive',
                value: false
              }
            ],
            render: data => {
              return <InputSwitch checked={data.is_active} onChange={(e) => changeStatus(data._id, e.value)} />;
            },
        },
        {
            id: uuid(),
            title: 'Action',
            sortable: false,
            style: { width: 200 },
            render: item => {
                return (
                    <div>
                        <EditButton title="Edit" onClick={onEdit(item)} />
                    </div>);
            },
        },
    ];

    const propsTable = { columns, getData: getFilters, enableFilter: true, showAddButton: true, filterRule: 'filter' };


    const onEdit = item => () => {
        reset(item);
        setState({ ...state, filter: item, showForm: true });
    }

    const onAddData = () => {
        onReset();
        setState({ ...state, showForm: true });
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onSubmit = (data) => {
        startProcessing();
        const response = filter._id ? updateFilter(filter._id, data) : createFilter(data);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    mTable.current.refresh();
                    filter._id ? onCloseForm() : onReset();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        reset({
            filter_name: '',
            is_active: true
        });
        setState({ ...state, filter: {} });
    }

    const onCloseForm = () => {
        reset({
            filter_name: '',
            is_active: true
        });
        setState({ ...state, filter: {}, showForm: false });
    }

    const { filter, processing, showForm } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <div className="card-header">
                                    <div className="card-title">
                                        <i className="fas fa-tags mr-1" />
                                        {showForm ? ' Form Asset Filter' : ' List Asset Filter'}
                                    </div>
                                </div>

                                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-body'>
                                        <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                                            <MTable ref={mTable} {...propsTable} onAddData={onAddData} showIndex={true} />
                                        </div>

                                        <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="type_code">Fields with <span className='mandatory'></span> are required.</label>
                                                    <div className='form-group'>
                                                        <label htmlFor="filter_name" className='mandatory'>Asset Filter Name</label>
                                                        <input id="filter_name" {...register("filter_name", { required: { value: true, message: 'Asset filter name is required!' } })} placeholder='Asset filter name' className='form-control' />
                                                        {errors.filter_name && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.filter_name.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="is_active">Active</label>
                                                        <div>
                                                            <Controller name="is_active" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} />) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        showForm && <div className='card-footer delay'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onCloseForm}><i className='fa fa-times' /> Close</button>
                                                        <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-sync' /> Clear</button>
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }}
                                                        >
                                                            <i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default FilterScreen;